import React from "react";
import { digitalMarketingServices } from "../data/digital-marketig";

const DigitalMarketingServices = () => {
  return (
    <div className="text-center">
      <p className="fs-20">Customized Digital Marketing Services</p>
      <h2 className="fs-28 gilroy-bold py-2">
        Great marketing is never one-size-fits-all
      </h2>
      <p className="fs-18 lh-30">
        Every business has unique goals and challenges, which is why we give
        every client a customized digital marketing strategy that combines a
        wide range of digital marketing services. At MWI, our solutions are
        always custom-tailored, never off-the-rack.
      </p>

      <div className="row mt-5 pt-5">
        {digitalMarketingServices.map((service) => (
          <div
            key={service.title}
            className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 text-center mb-5"
          >
            <div className="digital-marketing-service-card cursor-pointer card-design-3">
              <div className="digital-marketing-service-card-header">
                <img
                  src={service.img}
                  loading="lazy"
                  alt={service.title}
                  className="digital-marketing-service-card-img"
                />
              </div>
              <div className="pt-5">
                <h3 className="fs-20 gilroy-bold pb-2">{service.title}</h3>
                <p className="fs-16 lh-30 text-align-justify">
                  {service.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DigitalMarketingServices;
